import Localized from "react-localization";

const images = new Localized({
  en: {
    download_appstore: require("./images/download_appstore.png"),
    download_playstore: require("./images/download_playstore.png"),
    graphic: require("./images/graphic.png"),
    ic_app: require("./images/ic_app.png"),
    ic_instagram: require("./images/ic_instagram.png"),
    web_01: require("./images/en/web_01.jpg"),
    web_02: require("./images/en/web_02.jpg"),
    web_03: require("./images/en/web_03.jpg"),
    web_04: require("./images/en/web_04.jpg"),
    web_05: require("./images/en/web_05.jpg"),
    web_06: require("./images/en/web_06.jpg"),
    web_07: require("./images/en/web_07.jpg"),
    web_08: require("./images/en/web_08.jpg"),
  },
  ko: {
    download_appstore: require("./images/download_appstore.png"),
    download_playstore: require("./images/download_playstore.png"),
    graphic: require("./images/graphic.png"),
    ic_app: require("./images/ic_app.png"),
    ic_instagram: require("./images/ic_instagram.png"),
    web_01: require("./images/ko/web_01.jpg"),
    web_02: require("./images/ko/web_02.jpg"),
    web_03: require("./images/ko/web_03.jpg"),
    web_04: require("./images/ko/web_04.jpg"),
    web_05: require("./images/ko/web_05.jpg"),
    web_06: require("./images/ko/web_06.jpg"),
    web_07: require("./images/ko/web_07.jpg"),
    web_08: require("./images/en/web_08.jpg"),
  },
});

export default images;
